import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetCerifikatCommand extends BasicCommand<SetCerifikatCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    fscCertifikat?: boolean;
    pefcCertifikat?: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetCerifikatCommand";
    constructor(init: (instance: SetCerifikatCommand) => void) {
        super("SetCerifikatCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
